import { gql } from '@apollo/client';

export const REGISTRATION_BASIC_DETAILS_QUERY = gql`
  query RegistrationBasicDetails($id: ID!) {
    patient(id: $id) {
      id
      firstName
      middleName
      lastName
      gender
      dob
      namePrefix
      preferredName
      socialSecurityNumber
    }
    nameTitle: listData(category: "nameTitle") {
      id
      name
    }
    genderRefData: listData(category: "gender") {
      id
      name
    }
    user {
      id
      isPso
    }
  }
`;

export const UPDATE_REGISTRATION_BASIC_DETAILS = gql`
  mutation UpdatePatientUsBasic(
    $id: ID!
    $firstName: String
    $middleName: String
    $lastName: String
    $namePrefix: String
    $preferredName: String
    $gender: String
    $socialSecurityNumber: String
    $dob: String
  ) {
    updatePatientUsBasic(
      id: $id
      firstName: $firstName
      middleName: $middleName
      lastName: $lastName
      namePrefix: $namePrefix
      preferredName: $preferredName
      gender: $gender
      socialSecurityNumber: $socialSecurityNumber
      dob: $dob
    ) {
      patient {
        id
        firstName
        middleName
        lastName
        namePrefix
        preferredName
        gender
        socialSecurityNumber
        dob
      }
    }
  }
`;
